import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { VIEW, DELETE } from "const"
import { MtProject } from "server/models"
import { projectsRoute } from "client/parts/routes"
import { hasAccess, forceRerenderContent } from "client/utils"
import { PRM_PROJECT, StoreType } from "client/store"
import {
    Link,
    Logo,
    UserIcon,
    DateFormatter,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

const Columns = () => {
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const userSettings = useSelector((state: StoreType) => state.system.userSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const projectLink = (project: MtProject, linkContent: any) => {
        const href = `${projectsRoute}/${VIEW}/${project.id}`
        return (
            <Link
                href={href}
                onClick={() => forceRerenderContent(href, dispatch)}
            >
                {linkContent}
            </Link>
        )
    }

    const { defaultLogo } = userSettings.project
    const deleteAccess = hasAccess(PRM_PROJECT, DELETE)
    const columns: TableColumn[] = [
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (project: MtProject) => (
                projectLink(project, <Logo table logo={project.logo || defaultLogo || Images.noImage} />)
            ),
        },
        {
            field: "publicId",
            header: lang.publicId,
            sortable: true,
            cellMinWidth: "100px",
            formatter: (project: MtProject) => projectLink(project, project.publicId),
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            formatter: (project: MtProject) => projectLink(project, project.name),
        },
        {
            field: "owner",
            header: lang.owner,
            cellMinWidth: "150px",
            formatter: (project: MtProject) => {
                const user = userList[project.owner]
                return <UserIcon user={user} size="sm" />
            },
        },
        {
            field: "participants",
            header: lang.participants,
            cellMinWidth: "150px",
            formatter: (project: MtProject) => {
                const userIds = (projectUserList && projectUserList[project.id]) || []
                const dataList: TablePopoverData[] = []
                userIds.forEach((userId) => {
                    const user = userList[userId]
                    dataList.push({
                        id: `${user.id}_${project.id}`,
                        title: <UserIcon user={user} size="sm" />,
                    })
                })

                return (
                    <TablePopover
                        id={`projectUsers${project.id}`}
                        dataList={dataList}
                        placement="right"
                        listStyle={false}
                        title={lang.participants}
                        showFirst={dataList.length === 1}
                        editAccess={false}
                    />
                )
            },
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (project: MtProject) => <DateFormatter date={project.createdAt} />,
        },
        {
            field: "updatedAt",
            header: lang.modified,
            sortable: true,
            formatter: (project: MtProject) => <DateFormatter date={project.updatedAt} />,
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: (project: MtProject) => deleteAccess || project.owner === userData.userId,
        },
    ]

    return columns
}
export default Columns
